import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export function AuthSuccess() {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuthSuccess = async () => {
            try {
                // Re-check authentication status
                if (!isAuthenticated) {
                    throw new Error('User not authenticated');
                }
                // Redirect to explore page
                navigate('/explore');
            } catch (error) {
                console.error('Failed to verify authentication:', error);
                navigate('/auth?error=verification_failed');
            }
        };

        handleAuthSuccess();
    }, [isAuthenticated, navigate]);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center">
            <div className="text-center">
                <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4" />
                <p className="text-muted-foreground">Completing authentication...</p>
            </div>
        </div>
    );
}
